import { createAsyncThunk } from '@reduxjs/toolkit'
import BrandingResource from './branding-resource-model'
import {
  delete_brandingResource,
  load_brandingResources,
  store_brandingResource,
} from './brandingResource-service'

export const LoadBrandingResourcesAsync = createAsyncThunk<any, any>(
  'composer/load/brandingResource',
  async (params: { uid: string }) => {
    return await load_brandingResources(params)
  },
)

export const CreateBrandingResourceAsync = createAsyncThunk<any, any>(
  'composer/create/brandingResource',
  async (params: BrandingResource) => {
    return await store_brandingResource(params)
  },
)

export const DeleteBrandingResourceAsync = createAsyncThunk<any, any>(
  'composer/delete/brandingResource',
  async (params) => {
    return await delete_brandingResource(params)
  },
)
